/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule } from '@spartacus/core';
import { CardModule, SpinnerModule } from '@spartacus/storefront';
import { DayjsFormatModule } from "../../../../utilities/date/dayjs-format.module";
import { UDXOrderQRModule } from '../../order-qr/udx-order-qr.module';
import { UdxOrderOverviewComponent } from './udx-order-overview.component';

@NgModule({
    exports: [UdxOrderOverviewComponent],
    imports: [
        CommonModule,
        I18nModule,
        CardModule,
        UDXOrderQRModule,
        FeaturesConfigModule,
        SpinnerModule,
        ConfigModule.withConfig({
            cmsComponents: {
                AccountOrderDetailsOverviewComponent: {
                    component: UdxOrderOverviewComponent,
                },
            },
        } as CmsConfig),
        DayjsFormatModule,
        UdxOrderOverviewComponent
    ],
})
export class UdxOrderOverviewModule {}
